import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import { getBaseApi } from "../../services/BaseApi";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            isLoading: true,
            shouldShowMainName: true,
            role: '',
            id: 0,
            name: '',
            currentDate: '',
            ids: [],
            wods: [],
            genders: [
                {
                    id: 'male',
                    name: LocService.t('label_gender_man')
                },
                {
                    id: 'female',
                    name: LocService.t('label_gender_woman')
                }
            ],
            selectedWods: -1,
            selectedGender: null,
            logoImage: null,
            sortType: 'ASC',
            results: new Map(),
            dynamicColors: {}
        }
    },
    computed : {
        orderedResults() {
            return [...this.results].sort((a, b) => {
                if (this.sortType === 'ASC') {

                    return a.finalResult - b.finalResult; // Rastući redosled
                } else {
                    return b.finalResult - a.finalResult; // Opadajući redosled
                }
            });
        }
    },
    methods: {
        getTrainingResultsForTrainingOfTheDaysWod: getTrainingResultsForTrainingOfTheDaysWod,
        getTrainingOfTheDayForPeriod: getTrainingOfTheDayForPeriod,
        clickSelectWod: clickSelectWod,
        getChipClass: getChipClass,
        isSelectedWod: isSelectedWod,
        clickSelectGender: clickSelectGender,
        getChipClassGender: getChipClassGender,
        isSelectedGender: isSelectedGender,
        getName: getName,
        getDynamicColor: getDynamicColor,
        formatNumber: formatNumber,
        formatWeightByMeasure: formatWeightByMeasure,
        normalizeTime: normalizeTime,
        goBack() {
            this.$router.back();
        }
    },

    created() {
    },

    beforeMount() {
        this.role = session.getRole();
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.currentDate = this.$route.query.date;
        this.ids = [];
        this.ids.push(this.id)

        this.logoImage = getBaseApi() + 'company-image/'+ CONFIG_COMPANY.NAME;
        this.dynamicColors = session.getAppColors();
        this.getTrainingOfTheDayForPeriod();
        // this.getTrainingResultsForTrainingOfTheDaysWod();
    }

}

function getDynamicColor(itemId){
    if(this.dynamicColors[itemId] != null){
        return 'color: #'+ this.dynamicColors[itemId];
    }
    return '';
}

function formatWeightByMeasure(weight, measure){
    if(weight == null) return "";
    if(measure === 'min' || measure === 'Min'){
        let formated = weight.toString()
            .replace(",", ":")
            .replace(".", ":");
        return normalizeTime(formated);
    }
    return weight
}


function normalizeTime(timeStr) {
    try{
        let [hours, minutes] = timeStr.split(":").map(Number);

        // Dodaj višak minuta na sate
        hours += Math.floor(minutes / 60);
        minutes = minutes % 60;

        // Formatiranje tako da minuti uvek budu dvocifreni
        return `${hours}:${minutes.toString().padStart(2, '0')}`;
    }catch (e){
        return timeStr;
    }
}

function formatNumber(num) {
    try{
        return Number.isInteger(num) ? num : num.toFixed(2);
    }catch (e){
        return num
    }
}

function getChipClass(item) {
    if (this.selectedWods === item.id) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedWod(item) {
    return this.selectedWods === item.id
}

function clickSelectWod(item) {
    if(this.selectedWods !== item.id){
        this.selectedWods = item.id;
        this.sortType = item.sortType;
        this.getTrainingResultsForTrainingOfTheDaysWod();
    }
}

function getChipClassGender(item) {
    if (this.selectedGender === item.id) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedGender(item) {
    return this.selectedGender === item.id
}

function clickSelectGender(item) {
    if(this.selectedGender === item.id){
        this.selectedGender = null
    }else{
        this.selectedGender = item.id
    }
    this.getTrainingResultsForTrainingOfTheDaysWod();
}

function getTrainingResultsForTrainingOfTheDaysWod(){
    let _self = this;
    if(this.selectedWods < 0) return;
    _self.isLoading = true
    // if(this.ids == null || this.ids.length <= 0) return;
    let listIds = [this.selectedWods];
    AdminApiService.getTrainingResultsForTrainingOfTheDaysWod(listIds, _self.selectedGender)
        .then((response) => {
            let mapResults = new Map();
            response.data.forEach( item => {
                if(mapResults.has(item.userId)){
                    mapResults.get(item.userId).push(item)
                }else{
                    mapResults.set(item.userId, [])
                    mapResults.get(item.userId).push(item)
                }
            })
            _self.results = [];
            for (let value of mapResults.values()) {
                let type = value[0].advanceOptions
                let measure = value[0].measure;
                var total = null;
                switch (type) {
                    case 'MIN': {
                        let minItem = value.reduce((min, item) => (item.weight < min.weight ? item : min), value[0]);
                        total = minItem.weight;
                        break;
                    }
                    case 'MAX': {
                        let maxItem = value.reduce((max, item) => (item.weight > max.weight ? item : max), value[0]);
                        total = maxItem.weight;
                        break;
                    }
                    case 'AVERAGE': {
                        total = value.reduce((sum, item) => sum + item.weight, 0) / value.length;
                        break;
                    }
                    case 'SUM': {
                        total = value.reduce((sum, item) => sum + item.weight, 0);
                        break;
                    }
                }
                let model = {
                    finalResult: total,
                    finalMeasure: measure,
                    details: false,
                    allResults: value
                }
                _self.results.push(model)
            }
            _self.isLoading = false
            // _self.results = mapResults;
        })
        .catch(error => {
            _self.isLoading = false
            console.log(error);
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTrainingOfTheDayForPeriod(){
    let _self = this;
    let model = {
        fromDate: this.currentDate,
        toDate: this.currentDate,
        type: "WOD"
    }

    AdminApiService.getUserTrainingOfTheDayForPeriod(model)
        .then((response) => {
            _self.wods = [];
            let mapNames = new Map();
            response.data.forEach( item => {
                mapNames.set(_self.getName(item), "")
                _self.wods.push({
                    id: item.id,
                    name: _self.getName(item),
                    sortType: item.sortType,
                    category: item.category
                })
            })
            _self.shouldShowMainName = mapNames.size > 1;
            if(_self.wods.length > 0){
                _self.clickSelectWod(_self.wods[0])
            }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}



// WEBPACK FOOTER //
// ./src/components/Wod/WodUserResults.js